import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/hooks/cms-redux';
import { createEntity, deleteEntity, getLimitsByCardId, getLimitsByProductId, reset, updateEntity, } from 'shared/lib/reducers/card-limit.reducer';
/**
 * Card limit list + mutations. `scope` selects product vs card list endpoints and refetch behavior.
 */
export function useCardLimitsList(scope, id) {
    const dispatch = useAppDispatch();
    const slice = useAppSelector(s => s.cardLimit);
    const limits = slice?.entities ?? [];
    const loading = slice?.loading ?? false;
    const updating = slice?.updating ?? false;
    const updateSuccess = slice?.updateSuccess ?? false;
    const ownerKey = `${scope}:${id}`;
    const [bag, setBag] = useState({ ownerKey, applied: undefined });
    useEffect(() => {
        dispatch(reset());
        setBag(b => (b.ownerKey === ownerKey ? b : { ownerKey, applied: undefined }));
    }, [ownerKey, dispatch]);
    useEffect(() => {
        if (!Number.isFinite(id)) {
            return;
        }
        const filters = bag.ownerKey === ownerKey ? bag.applied : undefined;
        if (scope === 'product') {
            dispatch(getLimitsByProductId(id, filters));
        }
        else {
            dispatch(getLimitsByCardId(id, filters));
        }
    }, [bag, ownerKey, scope, id, dispatch]);
    useEffect(() => {
        if (!updateSuccess || !Number.isFinite(id)) {
            return;
        }
        const filters = bag.ownerKey === ownerKey ? bag.applied : undefined;
        if (scope === 'product') {
            dispatch(getLimitsByProductId(id, filters));
        }
        else {
            dispatch(getLimitsByCardId(id, filters));
        }
    }, [updateSuccess, bag, ownerKey, scope, id, dispatch]);
    const applyListFilters = useCallback((f) => {
        setBag({ ownerKey, applied: f });
    }, [ownerKey]);
    const clearListFilters = useCallback(() => {
        setBag({ ownerKey, applied: undefined });
    }, [ownerKey]);
    const createLimit = useCallback((entity) => dispatch(createEntity(entity)), [dispatch]);
    const updateLimit = useCallback((entity) => dispatch(updateEntity(entity)), [dispatch]);
    const deleteLimit = useCallback((lid) => dispatch(deleteEntity(lid)), [dispatch]);
    return {
        limits,
        loading,
        updating,
        updateSuccess,
        createLimit,
        updateLimit,
        deleteLimit,
        applyListFilters,
        clearListFilters,
    };
}
